// @/components/auth/TokenHandler.jsx
// Dispatches the correct token card based on validation status

import React from "react";
import useToken from '@/hooks/token/useToken';
import ValidTokenCard, { ValidTokenCardSkeleton } from "./ValidTokenCard";
import TokenStatusCard from "./TokenStatusCard";
import AuthLayout from "./AuthLayout";

const TokenHandler = () => {
  const { processing, tokenData, tokenStatus, error, loginToAccept } = useToken();

  if (processing) {
    return (
      <AuthLayout>
        <ValidTokenCardSkeleton />
      </AuthLayout>
    );
  }

  if (!tokenStatus) return null;

  return (
    <AuthLayout>
      {tokenStatus === 'valid' && tokenData && (
        <ValidTokenCard
          tokenData={tokenData}
          onLoginToAccept={loginToAccept}
        />
      )}
      {tokenStatus === 'completed' && (
        <TokenStatusCard variant="completed" />
      )}
      {tokenStatus === 'invalid' && (
        <TokenStatusCard variant="invalid" errorMessage={error} />
      )}
    </AuthLayout>
  );
};

export default TokenHandler;
